import { permissionsSelector } from "modules/Login/selectors/permissionSelector";
import { PERMISSIONS } from "modules/PermissionsConstants";
import { useRecoilValue } from "recoil";
import { OfficeApplianceTable } from "./view/OfficeApplianceTable";

export const OfficeAppliance = () => {
  const viewPermission = PERMISSIONS.permission_officeappliance_view;
  const userPermissions = useRecoilValue(permissionsSelector);
  return (
    <>
      {userPermissions.includes(viewPermission) ? <OfficeApplianceTable /> : ""}
    </>
  );
};
